import { Component, OnInit,Input,EventEmitter,Output} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { StudyUnitModel } from 'src/app/Models/StudyUnit';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VStudyUnit } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';
import { ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, distinctUntilChanged, finalize, switchMap } from 'rxjs/operators';
import {
  ISelectedNodes,
  ITreeNode,
} from '../content-studyunit-topics/content-studyunit-topics.component';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RelocateTopicContentComponent } from '../relocate-topic-content/relocate-topic-content.component';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-content-study-unit',
  templateUrl: './content-study-unit.component.html',
  styleUrls: ['./content-study-unit.component.css'],
})
export class ContentStudyUnitComponent implements OnInit {
  @Input() subjectById: any;
  @Input() StudyUnitEditList: any;
  @Input() EditStudyUnitflag: any;
  @Input() AddStudyUnitflag: any;
  @Input() Refresh: any;
  @Output() getsubjectDataRefresh: EventEmitter<any> = new EventEmitter<any>();
  @Output() AddStudyUnitSubject: EventEmitter<any> = new EventEmitter<any>();
  @Output() StudyUnitClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelbutton: EventEmitter<any> = new EventEmitter<any>();
  InsertStudyUnit: StudyUnitModel;
  AddStudyUnitform: FormGroup;
  tempvariable: boolean = false;
  course_Id: string;
  studyUnitSubjectList: ISelectedNodes[] = [];
  constructor(
    private cdr: ChangeDetectorRef,
    public service: ContentManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) {}
  InitializeForm() {
    this.AddStudyUnitform = this.fb.group({
      Study_Unit_Name: ['', Validators.required],
      Display_Order: [{ value: 0, disabled: true }, VStudyUnit],
      Description_Text: [''],
    });
  }
  ngOnInit() {
    this.route.queryParams.subscribe((e) => {
      this.course_Id = e.c_id;
    });
    this.InitializeForm();
    if (this.StudyUnitEditList != null) {
      this.getStudyUnit(this.StudyUnitEditList.ID);
      this.getStudyUnitSubject(this.StudyUnitEditList.ID);
    } else {
      this.getStudyUnit(null);
    }
    this.getBreadcrumbDetails();

    this.Descriptioncount();

    this.AddStudyUnitform.get('Study_Unit_Name')!
      .valueChanges.pipe(
        debounceTime(400), // Wait 300ms after the last keystroke
        distinctUntilChanged() // Only emit when the value changes
      )
      .subscribe((value: string) => {
        this.subjectvaluelength = value.length;
        this.SubjectNamecount(value);
      });
  }

  RelocateTopic() {
    const modalRef = this.modalService.open(RelocateTopicContentComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    const SubjectParentInput = {
      Subject_Id: this.subjectById.Subject_Id,
      Parent_Subject_Id: Number(0),
      Selected_Header_ID: Number(0),
      Refresh: this.Refresh,
      subjectParentEnable: true,
    };
    modalRef.componentInstance.SubjectParentInput = SubjectParentInput;
    modalRef.componentInstance.Refresh = '';
    modalRef.componentInstance.MajorTopic = '';
    modalRef.componentInstance.subjectParentEnable = '';
    modalRef.componentInstance.StudyUnit = {
      ...this.AddStudyUnitform.value,
      SubjectId: this.subjectById.Subject_Id,
      Study_Unit_Id: this.StudyUnit[0].Study_Unit_Id,
      Study_Unit_Status_Type_Code: 'WIP',
      Course_Id: +this.course_Id,
    };
    modalRef.result.then(
      (result) => {
        console.log('Modal closed with result:', result);
        this.getsubjectDataRefresh.emit(this.Refresh);
        this.cancelbutton.emit(this.Modalclose);
        if (result === 'Success') {
        }
      },
      (dismiss) => {
        console.log('Modal dismissed:', dismiss);
      }
    );
    // modalRef.componentInstance.param = this.ScreenName;
  }
  getStudyUnitSubject(data: any) {
    this.service.GetStudyUnitSubject({ Study_Unit_Id: data }).subscribe(
      (res: any) => {
        this.studyUnitSubjectList = res.MasterList;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  Breadcrumblist: any;
  Breadcrumb: string;
  ID: number;
  getBreadcrumbDetails() {
    // this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
    //   this.Breadcrumblist = i;
    if (this.EditStudyUnitflag) {
      this.ID = this.StudyUnitEditList.ID;
    }
    if (this.AddStudyUnitflag) {
      this.ID = this.subjectById.Subject_Id;
    }
    this.service
      .getBreadcrumb({ ID: this.ID, Screenname: 'CONTENT_MANAGEMENT' })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          this.Breadcrumb = this.Breadcrumblist.Data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  StudyUnit: any;
  StudyUnitDetailsflag: boolean = false;
  topicflag: boolean;

  getStudyUnit(data: any) {
    this.service.GetStudyUnit$({ Study_Unit_Id: data }).subscribe(
      (res: any) => {
        this.StudyUnit = res?.StudyUnitList;
        this.StudyUnitDetailsflag = false;
        if (this.StudyUnit && this.StudyUnit.length > 0) {
          console.log(this.StudyUnit[0].Study_Unit_Id);
          if (this.StudyUnit[0].Study_Unit_Id != null) {
            this.StudyUnitDetailsflag = true;
            this.AddStudyUnitform.controls['Study_Unit_Name'].setValue(
              this.StudyUnit[0].Study_Unit_Name
            );
            this.AddStudyUnitform.controls['Display_Order'].setValue(
              this.StudyUnit[0].Display_Order
            );
            this.AddStudyUnitform.controls['Description_Text'].setValue(
              this.StudyUnit[0].Description_Text
            );
          }
        }
        if (this.AddStudyUnitflag) {
          this.StudyUnitClose.emit(this.StudyUnitDetailsflag);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }


  get isSaveDisabled(): boolean {
  const a = !!this.namevalidate; // make sure this is boolean, not a non-empty string
  const c = !(this.AddStudyUnitform?.valid ?? false); // safe if form not ready yet
  const d = !!this.EditStudyUnitflag && !!!this.tempvariable;

  // TEMP debug
  // console.table({ a_namevalidate: a, c_formInvalid: c, d_editTemp: d });
  // console.log(this.StudyUnitDetailsflag);
  // console.log(this.AddStudyUnitflag);

  return a || c || d;
}

  StudyUnitlists: any;

  StudyUnitResponse: any;
  Modalclose: boolean;
  loading = false;
  AddStudyUnit() {
    if (!this.AddStudyUnitform.valid) return;

    const studyunitName = this.AddStudyUnitform.get('Study_Unit_Name')!.value;
    this.loading = true;

    this.service
      .getDuplicateNameValidation({
        ParentSubjectID: this.StudyUnit?.[0]?.Study_Unit_Id ?? null,
        SubjectElementName: studyunitName,
        screenName: `STUDY_UNIT@${this.course_Id}`,
      })
      .pipe(
        switchMap((res: any) => {
          const isDuplicate = res?.SubjectExistsInd === 'Y';
          this.namevalidate = isDuplicate;

          if (isDuplicate) {
            this.toastr.error(
              'Name already exists, please choose a different name.'
            );
            // Stop the observable chain cleanly
            return EMPTY;
          }

          // Build payload then save
          this.InsertStudyUnit = {
            ...this.AddStudyUnitform.value,
            SubjectId: this.subjectById.Subject_Id,
            Study_Unit_Id: this.StudyUnit?.[0]?.Study_Unit_Id ?? null,
            Study_Unit_Status_Type_Code: 'WIP',
            Course_Id: this.course_Id ? +this.course_Id : undefined,
          };

          return this.service.CreateOrModifyStudyUnit(this.InsertStudyUnit);
        }),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: (i: any) => {
          if (i.Message?.includes('XAK1STUDY_UNIT')) {
            this.toastr.error('Name Already Exists');
            return;
          }

          if (i.Message === 'Success') {
                  this.toastr.success('Saved Successfully', 'Success',{timeOut: ConstantVars.ToastSucessTimeout});
            this.getStudyUnit(i.Value || this.StudyUnit?.[0]?.Study_Unit_Id);
            if (this.EditStudyUnitflag) {
              this.getsubjectDataRefresh.emit(this.Refresh);
              this.cancelbutton.emit(this.Modalclose);
            }
          } else {
            this.toastr.error(i.Message);
          }
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong.');
        },
      });
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddStudyUnitform.controls.Description_Text.value != '' &&
      this.AddStudyUnitform.controls.Description_Text.value != null
    ) {
      if (this.AddStudyUnitform.controls.Description_Text.value.length > 0) {
        this.Descriptionvaluelength =
          this.AddStudyUnitform.controls.Description_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
    this.Editformvalidation();
  }

  subjectvaluelength: any;
  subjectMaxlength: number = 250;
  SubjectNamecount(Study_Unit_Name: string) {
    if (Study_Unit_Name != '' && Study_Unit_Name != null) {
      if (Study_Unit_Name.length > 0) {
        this.subjectvaluelength = Study_Unit_Name.length;
      } else {
        this.subjectvaluelength = 0;
      }
    } else {
      this.subjectvaluelength = 0;
    }
    this.Editformvalidation();
    // this.Studyunitnamevalidation();
  }

  checkDuplicate() {
    const studyunitName =
      this.AddStudyUnitform.controls['Study_Unit_Name'].value;
    this.service
      .getDuplicateNameValidation({
        ParentSubjectID: this.StudyUnit[0].Study_Unit_Id
          ? this.StudyUnit[0].Study_Unit_Id
          : null,
        SubjectElementName: studyunitName,
        screenName: `STUDY_UNIT@${this.course_Id}`,
      })
      .subscribe(
        (i: any) => {
          this.StudyunitExistsInd = i;
          if (this.StudyunitExistsInd.SubjectExistsInd == 'Y') {
            this.namevalidate = true;
          } else {
            this.namevalidate = false;
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
  }
  StudyunitExistsInd: any;
  namevalidate: boolean = false;
  Studyunitnamevalidation() {
    var slice = this.AddStudyUnitform.controls['Study_Unit_Name'].value;
    var StudyUnitId;
    if (this.StudyUnit != null) {
      if (this.StudyUnit.length > 0) {
        if (this.StudyUnit != null) {
          if (this.StudyUnit[0].Study_Unit_Id != null) {
            StudyUnitId = this.StudyUnit[0].Study_Unit_Id;
          } else {
            StudyUnitId == null;
          }
        } else {
          StudyUnitId == null;
        }
      } else {
        StudyUnitId == null;
      }
    } else {
      StudyUnitId == null;
    }
    //var Name = slice.split(':').pop();
    if (slice != '' && slice != undefined && slice != null) {
      this.service
        .getDuplicateNameValidation({
          ParentSubjectID: StudyUnitId,
          SubjectElementName: slice,
          screenName: 'STUDY_UNIT',
        })
        .subscribe(
          (i: any) => {
            this.StudyunitExistsInd = i;
            if (this.StudyunitExistsInd.SubjectExistsInd == 'Y') {
              if (this.StudyUnit[0].Study_Unit_Name == slice) {
                this.namevalidate = false;
              } else {
                this.namevalidate = true;
              }
            } else {
              this.namevalidate = false;
            }
          },
          (error: any) => {
            console.log(error);
          }
        );
    }
  }

  StudyUnitSubjectflag: boolean;
  AddSubject() {
    if (this.StudyUnitDetailsflag)
      this.AddStudyUnitSubject.emit(this.StudyUnit[0]);
  }

  StudyUnitID: any;
  StudyUnitPopupflag: any;
  StudyUnitTopicPopup() {
    this.StudyUnitID = this.StudyUnit[0];
    this.StudyUnitPopupflag = !this.StudyUnitPopupflag;
  }

  CloseStudyUnitTopics() {
    if (this.StudyUnitPopupflag) {
      this.StudyUnitTopicPopup();
    }
  }

  Cancel() {
    console.log(this.studyUnitSubjectList);
    this.cancelbutton.emit(this.Modalclose);
    // if (
    //   this.studyUnitSubjectList.some((e) => e.Selected_For_Current_Study_Unit_IND === 'Y')
    // ) {
    //   this.cancelbutton.emit(this.Modalclose);
    // } else {
    //   this.toastr.error('Please Select a Study Unit Subject', '', {
    //     timeOut: ConstantVars.ToastErrorTimeout,
    //   });
    // }
  }

  Editformvalidation() {
    if (this.AddStudyUnitform.valid && this.EditStudyUnitflag) {
      var Study_Unit_Name =
        this.AddStudyUnitform.controls['Study_Unit_Name'].value;
      var Display_Order = this.AddStudyUnitform.controls['Display_Order'].value;
      var Description_Text =
        this.AddStudyUnitform.controls['Description_Text'].value;

      if (Description_Text == '') {
        Description_Text = null;
      }

      if (Study_Unit_Name != this.StudyUnit[0].Study_Unit_Name)
        this.tempvariable = true;
      else if (Display_Order != this.StudyUnit[0].Display_Order)
        this.tempvariable = true;
      else if (Description_Text != this.StudyUnit[0].Description_Text)
        this.tempvariable = true;
      else this.tempvariable = false;
    }
  }
}
